import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import {
    AfterViewInit, ChangeDetectionStrategy,
    ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { MatSort, MatSortable, Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Moment } from 'moment';
import { TableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { BehaviorSubject, combineLatest, firstValueFrom, Observable, of, Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, first, map, pairwise, shareReplay, skip, startWith, switchMap, take, takeUntil, tap, withLatestFrom } from 'rxjs/operators';
import { SimplebarAngularComponent } from 'simplebar-angular';
import { BurgerButtonWrapperComponent } from '../../../burger-button-wrapper/burger-button-wrapper.component';
import { DaveFileUploadDialogComponent, DaveFileUploadDialogComponentDialogData } from '../../../components/templates/new-document-view/component/dave-file-upload-dialog/dave-file-upload-dialog.component';
import {
    DocumentState,
    FileEntity,
    FileEntityDocumentStateNames,
    getFileIconByMimeType, GetFileMimeTypeText,
    NEW_DOCUMENT_DEFAULT_NAME,
} from '../../../dave-data-module/entities/file.entity';
import { FolderEntity, FolderTypes } from '../../../dave-data-module/entities/folder.entity';
import { DmsViewStyle } from '../../../dave-data-module/entities/user.entity';
import { CommissionResolver } from '../../../dave-data-module/guards/commission.resolver';
import { TagResolver } from '../../../dave-data-module/guards/tag.resolver';
import { FileDataService } from '../../../dave-data-module/services/file-data.service';
import { DownloadVersions, DownloadZip, HttpService } from '../../../dave-data-module/services/http.service';
import { State } from '../../../dave-data-module/State';
import { FilesActionTypes } from '../../../dave-data-module/State/actions/files.actions';
import { FolderActionTypes } from '../../../dave-data-module/State/actions/folder.actions';
import { ChangeSettings } from '../../../dave-data-module/State/actions/settings.actions';
import { getToken } from '../../../dave-data-module/State/selectors/base.selectors';
import { getCommissions, getCommissionsFetched } from '../../../dave-data-module/State/selectors/commission.selector';
import { getFileById, getFilesWithoutHidden } from '../../../dave-data-module/State/selectors/files.selectors';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Actions, ofType } from '@ngrx/effects';
import { FolderDataService } from '../../../dave-data-module/services/folder-data.service';
import { getTagFetched, getTags } from '../../../dave-data-module/State/selectors/tag.selectors';
import { getSetting } from '../../../dave-data-module/State/selectors/users.selectors';
import { EmailEditorComponent, EmailEditorComponentDialogConfig, EmailEditorComponentDialogData } from '../../../dave-email-module/components/email-editor/email-editor.component';
import { DaveFilePreviewComponent, DaveFilePreviewComponentDialogData } from '../../../dave-file-preview-dialog/components/dave-file-preview/dave-file-preview.component';
import { AppDialogService } from '../../../dave-utils-module/app-dialog-module/app-dialog.service';
import { FilterOption, FILTER_TYPE_SEARCH_MULTI_SELECT, FILTER_TYPE_TIMESPAN, IFilterTypeSearchMultiSelectValue } from '../../../dave-utils-module/app-filter-module/app-filter/app-filter.component';
import { isNotNullOrUndefined, uniqArray } from '../../../helper/helper';
import {
    CommissionMeta,
    FileLinkIcon,
    InvoiceEditorMeta,
    MaterialPageMeta,
    ProcessMeta,
} from '../../../helper/page-metadata';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import { FileExplorerSortingService } from '../../../services/fileexplorer-sorting.service';
import { LoadingService } from '../../../services/loading.service';
import { MoveFileFolderService } from '../../../services/move-file-folder.service';
import { SortFilesDialogComponent, SortFilesDialogComponentDialogData } from '../../../sort-files-dialog/sort-files-dialog.component';
import { DynamicFolderTreeDataService, DynamicFolderTreeFlatNode } from '../../dynamic-folder-tree-data.service';
import { NewFolderDialogComponent, NewFolderDialogComponentDialogData } from '../new-folder-dialog/new-folder-dialog.component';
import { ViewFolderComponent, ViewFolderComponentDialogData } from '../view-folder/view-folder.component';
import { dmsFolderTreeControl, FolderTreeControl } from './folder-tree-control';
import { DynamicFolderTreeDataSource, DynamicFolderTreeDataSourceInterface } from './folder-tree-datasource';
import { getPartner } from '../../../dave-data-module/State/selectors/partners.selectors';
import { PartnerTypeEnum } from '../../../dave-data-module/entities/partner.entity';
import { ProcessService } from '../../../services/process.service';
export const sortByName = (a: {Name: string}, b: {Name: string}): 1 | -1 | 0 => {
    const aName = a.Name.toLowerCase();
    const bName = b.Name.toLowerCase();
    return aName < bName ? -1 : aName > bName ? 1 : 0;
};
import {
    PermissionService
} from '../../../dave-utils-module/dave-shared-components-module/services/permission.service';
import { FilePopupServiceService } from '../../file-popup-service.service';
import { AppGatewayService } from '../../../dave-data-module/services/app-gateway.service';
import { BaseActionTypes } from '../../../dave-data-module/State/actions/base.actions';
import { ToastrService } from 'ngx-toastr';
import { SurchargeRateResolver } from '../../../dave-data-module/guards/surcharge-rate.resolver';
import { SharepointFolderTreeDataSource } from './sharepoint/sharepoint-folder-tree-datasource';
import { SharepointDataService } from './sharepoint/sharepoint-data.service';
import { SharepointFolderTreeControl } from './sharepoint/sharepoint-folder-tree-control';
import { FlatTreeControl } from '@angular/cdk/tree';
import { SharepointObjectEntity } from '../../../dave-data-module/entities/sharepoint-object.entity';
import { dmsFolder, DmsFolderDataWrapperService } from './dms-folder-data-wrapper.service';
import {
    SharepointObjectPreviewDialogComponent, SharepointObjectPreviewDialogComponentDialogData,
    SharepointObjectPreviewDialogComponentDialogReturnData,
} from './sharepoint/sharepoint-file-preview-dialog/sharepoint-object-preview-dialog.component';
import { SharepointRootFolder } from '../../../dave-data-module/entities/commission.entity';

interface ExplorerElement {
    name: string;
    id: number | string;
    isFolder: boolean;
    isLink: boolean;
    size?: number;
    createdAt?: Date;
    updatedAt?: Date;
    fileType?: string;
    thumbnailPath?: string;
    prevSelected$?: Observable<boolean>;
    icon?: IconProp;
    isChecked?: boolean;
    isCharged?: boolean;
    searchStrings: string[];
    additionalColumns: Map<string,string>;
    remark?: string;
    external?: {
        isSharepoint: boolean;
        directOpenUrl?: string;
    }
}

export const MatTreeNodePaddingIndent = 10; // in px

interface FileFilter {
    tagIds: IFilterTypeSearchMultiSelectValue<number>[];
    commissionIds: IFilterTypeSearchMultiSelectValue<number>[];
    createdAt: { to: Moment; from: Moment };
    updatedAt: { to: Moment; from: Moment };
}

type folderIdType = string | number;
type fileIdType = string | number;

interface AdditionalColumnsOption {
    name: string;
    column: string;
    size: string|null;
}

@Component({
    selector: 'app-file-explorer',
    templateUrl: './file-explorer.component.html',
    styleUrls: ['./file-explorer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [DmsFolderDataWrapperService],
})
export class FileExplorerComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() EmailEditorDialogDataForFilePreview: Partial<EmailEditorComponentDialogData>;
    @Input() ShowTree = false;
    private disableBackButtonFolderId$ = new BehaviorSubject<folderIdType>(undefined);
    @Input() set DisableBackButtonFolderId(v: folderIdType) {
        this.disableBackButtonFolderId$.next(v);
    }
    public Minimalistic$ = new BehaviorSubject(false);
    @Input()
    set Minimalistic(value) {
        this.Minimalistic$.next(coerceBooleanProperty(value));
    }
    // tslint:disable-next-line: member-ordering naming-convention
    static ngAcceptInputType_Minimalistic: BooleanInput;
    public ViewStyleOverride$ = new BehaviorSubject<DmsViewStyle | null>(null);
    @Input() set ViewStyle(v: DmsViewStyle) {
        this.ViewStyleOverride$.next(v);
    }
    @Input() ShowScan2DaveButton = false;
    @Input() DisableRoutingParams = false;
    @Input() FileUploadButton = false;
    @Input() FileUploadConfig: DaveFileUploadDialogComponentDialogData = {};

    @Input()
    set PreventFileClick(value) {
        this.preventFileClick = coerceBooleanProperty(value);
    }
    // tslint:disable-next-line: member-ordering naming-convention
    static ngAcceptInputType_PreventFileClick: BooleanInput;
    @Input()
    set PreventFileUploadClick(value) {
        this.preventFileUploadClick = coerceBooleanProperty(value);
    }

    @Input()
    set additionalColumns(value: AdditionalColumnsOption[]){
        this._additionalColumns.next(value);
    }
    protected _additionalColumns = new BehaviorSubject<AdditionalColumnsOption[]>([])

    @Input()
    set hideColumns(value: Array<keyof ExplorerElement | 'select' | 'options'>){
        this._hideColumns.next(value);
    }
    protected _hideColumns = new BehaviorSubject<string[]>([])

    protected extraColumns = new BehaviorSubject<string[]>([]);
    // tslint:disable-next-line: member-ordering naming-convention
    static ngAcceptInputType_PreventFileUploadClick: BooleanInput;
    @Output() Scan2DaveClicked$ = new EventEmitter<number>();
    @Output() FilterOpen$ = new EventEmitter<boolean>();
    @Output() FileClicked = new EventEmitter<number>();
    @Output() FileUploadClicked = new EventEmitter<number>();
    @Output() fileExplorerContext = new EventEmitter<{ directoryFileIds: number[] } | undefined>();

    protected _sharepointMode$ = new BehaviorSubject(false);
    private _sharepointRootFolder: SharepointRootFolder | null = null;
    // @Input() set sharepointMode(bool: boolean) {
    //     if (!!bool !== this._sharepointMode) {
    //         this._sharepointMode = !!bool;
    //         this.setFolderDataServiceMode();
    //         this.setDatasource();
    //         this.cdr.markForCheck();
    //     }
    // }
    // get sharepointMode() {
    //     return this._sharepointMode;
    // }
    @Input() set sharepointRootFolder(folder: SharepointRootFolder) {
        const id = folder?.Id;
        const sharepointMode = !!id;
        let dirty = false;
        if (!!sharepointMode !== this._sharepointMode$.value) {
            dirty = true;
            this._sharepointMode$.next(!!sharepointMode);
            this.setFolderDataServiceMode();
        }
        if (id !== this._sharepointRootFolder?.Id || folder?.NameOverride !== this._sharepointRootFolder?.NameOverride) {
            dirty = true;
            this._sharepointRootFolder = folder;
        }
        if (dirty) {
            this.setDatasource();
        }
    }
    get sharepointRootFolder() {
        return this._sharepointRootFolder;
    }
    @Input() expanded = true;
    @Input() expandable = true;
    @Input() contentHeight = '36rem';
    private preventFileClick = false;
    private preventFileUploadClick = false;
    public OpenMailDialog$: Subject<void> = new Subject<void>();
    public StartUglImport$: Subject<void> = new Subject<void>();
    public ViewStyle$ = this.ViewStyleOverride$.pipe(
        switchMap((v) =>
            v
                ? of(v)
                : this.Minimalistic$.pipe(
                      switchMap((minimalistic) =>
                          minimalistic
                              ? of(DmsViewStyle.Tile)
                              : this.store.select(getSetting).pipe(
                                    map((setting) => setting?.DmsViewStyle),
                                    map((s) => (s === undefined || s === DmsViewStyle.OldDms ? DmsViewStyle.List : s)),
                                ),
                      ),
                  ),
        ),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    public ShowNotFoundError: boolean;
    public Math = Math;

    @HostListener('window:resize')
    sizing() {
        const smallWidth = this.ElementRef?.nativeElement.offsetWidth < 640;
        if (this.Small$.value !== smallWidth) {
            this.Small$.next(smallWidth);
        }
    }

    public Small$ = new BehaviorSubject(true);
    public dynamicTreeControl: FlatTreeControl<DynamicFolderTreeFlatNode<folderIdType>, DynamicFolderTreeFlatNode<folderIdType>>&dmsFolderTreeControl<folderIdType>;

    public ViewStyles = DmsViewStyle;
    public DisplayedColumns$: Observable<Array<keyof ExplorerElement | 'select' | 'options'>> = combineLatest([
        this.Small$,
        this._additionalColumns,
        this._hideColumns
    ]).pipe(
        map(([mobile, additionalColumns, hideColumns]) => (mobile ? ['name', 'fileType', 'createdAt', 'updatedAt', 'options'] : ['name', ...additionalColumns.map(c => c.column), 'fileType', 'createdAt', 'updatedAt', 'size', 'options']).filter(c => !hideColumns.includes(c))),
        switchMap((cols: Array<keyof ExplorerElement | 'select' | 'options'>) => this.Multiselect$.pipe(map((ms) => (ms ? ['select' as 'select', ...cols] : cols)))),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    public SelectedFolderId$ = new BehaviorSubject<folderIdType>(null);
    public SelectedFileId$ = new BehaviorSubject<number>(null);

    public PreviousSelectedFolderId$ = this.SelectedFolderId$.pipe(
        distinctUntilChanged(),
        startWith(null),
        pairwise(),
        map(([prev, curr]) => prev),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    public OpenInSharepoint(){
        this.SelectedFolderId$.pipe(
            take(1),
            switchMap(id => this.sharepointDataService.getFolderById(id.toString())),
            take(1)
        ).subscribe(folder => {
            window.open(folder.Url);
        })
    }

    // public PreviousSelectedFolderId$ = this.SelectedFileId$.pipe(
    //     switchMap(fileId => {
    //         if (fileId !== null) {
    //             return this.SelectedFolderId$.pipe(
    //                 startWith(null),
    //                 pairwise(),
    //                 map(([prev, curr]) => prev)
    //             );
    //         } else {
    //             return this.SelectedFolderId$.pipe(
    //                 distinctUntilChanged(),
    //                 startWith(null),
    //                 pairwise(),
    //                 map(([prev, curr]) => prev )
    //             );
    //         }
    //     }),
    //     distinctUntilChanged(),
    //     shareReplay({ refCount: true, bufferSize: 1 })
    // );

    public CurrentSelectedFileId$ = this.SelectedFileId$.pipe(
        distinctUntilChanged(),
        startWith(null),
        pairwise(),
        map(([prev, curr]) => curr),
        distinctUntilChanged(),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    public Path$ = this.SelectedFolderId$.pipe(
        distinctUntilChanged(),
        switchMap((id) => (id ? this.dynamicTreeDataSource.path$(id) : of(null))),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    folderNavigateUpDisabled$ = combineLatest([
        this.SelectedFolderId$,
        this.Path$,
        this.disableBackButtonFolderId$
    ]).pipe(
        map(([SelectedFolderId, path, DisableBackButtonFolderId]) => {
            return !path || (SelectedFolderId === DisableBackButtonFolderId)
        })
    )
    public foldersBySelectedParent$ = this.SelectedFolderId$.pipe(
        map((id) => id || null),
        distinctUntilChanged(),
        tap(() => this.LoadingFolders$.next(true)),
        switchMap((id) => this.folderDataService.getFolderByParent(id)),
        tap(() => this.LoadingFolders$.next(false)),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    protected dynamicTreeDataSource: DynamicFolderTreeDataSourceInterface<folderIdType>;

    public Folder$: Observable<{
        folders: dmsFolder<folderIdType>[];
        files: FileEntity[];
        sharePointFiles: SharepointObjectEntity[];
    }>;
    public ShownElements$: Observable<ExplorerElement[]> = new BehaviorSubject([]);
    public ShownElementsTableDataSource$: Observable<TableVirtualScrollDataSource<ExplorerElement>> /* = new BehaviorSubject(new TableVirtualScrollDataSource([]))*/;
    public BaseUrl = this.api.GetUrl('', 'file');
    public PathIds$: Observable<folderIdType[]> = new BehaviorSubject([]);
    public FolderMultisilect$ = new BehaviorSubject<number[]>([]);
    public FileMultisilect$ = new BehaviorSubject<number[]>([]);
    protected mergePdfDisabled$ = combineLatest([this.FileMultisilect$, this.FolderMultisilect$]).pipe(
        switchMap(([fileIds, folderIds]) => {
            if (!fileIds || fileIds.length < 2 || folderIds?.length) {
                return of(true);
            } else {
                return this.fileDataService.GetFilesById(fileIds).pipe(
                    first(),
                    map((files) => files.some((f) => f?.MIMEType !== 'application/pdf')),
                );
            }
        }),
    );
    protected uploadUglsDisabled$ = combineLatest([this.FileMultisilect$, this.FolderMultisilect$]).pipe(
        switchMap(([fileIds, folderIds]) => {
            if (!fileIds || fileIds.length < 1 || folderIds?.length) {
                return of(true);
            } else {
                return this.fileDataService.GetFilesById(fileIds).pipe(
                    first(),
                    map((files) => !files.every((f) => f?.Name.toLowerCase().endsWith('.ugl') || /\.\d+$/.test(f?.Name.toLowerCase()))),
                );
            }
        }),
    );
    public IsAllSelected$: Observable<boolean> = new BehaviorSubject(false);
    public Multiselect$ = new BehaviorSubject(false);
    public ShowDataSearch = false;
    public DataSearchForm = new FormControl<string>('');
    public FolderNameForm = new FormControl<string>('');
    public ClickMove$: Subject<void> = new Subject<void>();
    public ClickDownload$: Subject<void> = new Subject<void>();
    public Commissions$ = this.store.select(getCommissions);
    public FolderWithTypeSelected$: Observable<boolean> = new BehaviorSubject(false);
    public Sharing$ = new BehaviorSubject<boolean>(true);
    // public ItemHeight = 138.25;
    public ItemHeight = 158;
    public ItemWidth = 80;
    public HasFolderEditPermission = false;
    @ViewChild(MatSort) private matSortDOM?: MatSort;
    @ViewChild('breadcrumbScrollbar') private breadcrumbScrollbar?: SimplebarAngularComponent;
    @ViewChild('scrollableTree') private treeWrapperScrollbar?: CdkVirtualScrollViewport;
    @ViewChild('drawer') private drawer?: MatDrawer;
    @ViewChild('buttonWrapper') private buttonWrapper?: BurgerButtonWrapperComponent;
    @ViewChild('scrollViewportForList') private scrollViewportForList?: CdkVirtualScrollViewport;
    @ViewChild('scrollViewportForTile') private scrollViewportForTile?: CdkVirtualScrollViewport;
    private subscriptions: Subscription[] = [];
    private onDestroy$ = new Subject<void>();
    private onInit$ = new BehaviorSubject<boolean>(false);
    private afterViewInit$ = new BehaviorSubject<boolean>(false);
    public FilterValues$: BehaviorSubject<FileFilter> = new BehaviorSubject({
        tagIds: [],
        commissionIds: [],
        createdAt: { to: null, from: null },
        updatedAt: { to: null, from: null },
    });

    public FilterSettings$: Observable<FilterOption<keyof FileFilter>[]> = combineLatest([
        this.store.select(getTags),
        this.store.select(getCommissions),
        this.cls.getMultiple$('Commission'),
        this._sharepointMode$
    ]).pipe(
        filter((v) => v.every(isNotNullOrUndefined)),
        map(([tags, commissions, commissionLabel, sharepointMode]) => {
            let tagValues = tags.map((c) => ({
                id: c.Id,
                label: c.Name,
            }));
            let commissionValues = commissions.map((c) => ({
                id: c.Id,
                label: c.optionLabel,
            }));
            const ret:FilterOption<keyof FileFilter>[] = [];
            if (!sharepointMode) {
                ret.push(
                    {
                        Name: 'tagIds',
                        Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                        Label: 'Schlagwörter',
                        Icon: 'tags',
                        Values: tagValues,
                    },
                    {
                        Name: 'commissionIds',
                        Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                        Label: commissionLabel,
                        Icon: CommissionMeta.Icon,
                        Values: commissionValues,
                    },
                )
            }
            ret.push(
                {
                    Name: 'createdAt',
                    Type: FILTER_TYPE_TIMESPAN,
                    Label: 'Datei hochgeladen',
                    Icon: 'calendar',
                },
                {
                    Name: 'updatedAt',
                    Type: FILTER_TYPE_TIMESPAN,
                    Label: 'Datei aktualisiert',
                    Icon: 'calendar',
                },
            )
            return ret;
        }),
    );
    public LoadingFiles$ = new BehaviorSubject(false);
    public LoadingFolders$ = new BehaviorSubject(false);
    protected showProgressBar$ = combineLatest([this.LoadingFiles$, this.LoadingFolders$]).pipe(
        map((loading) => {
            return loading.some((l) => l);
        }),
        distinctUntilChanged(),
    );
    private openFileDialogs: MatDialogRef<DaveFilePreviewComponent | SharepointObjectPreviewDialogComponent>[] = [];

    // protected dynamicTreeDataAsArray$: Observable<DynamicFolderTreeFlatNode[]>;
    constructor(
        private moveFileFolderService: MoveFileFolderService,
        private api: HttpService,
        private store: Store<State>,
        tagResolver: TagResolver,
        commissionResolver: CommissionResolver,
        private dialog: MatDialog,
        private sortService: FileExplorerSortingService,
        private appDialog: AppDialogService,
        protected route: ActivatedRoute,
        protected router: Router,
        private fileDataService: FileDataService,
        public ElementRef: ElementRef,
        protected cls: CustomLabelService,
        private actions$: Actions,
        private ls: LoadingService,
        private folderDataService: DmsFolderDataWrapperService,
        private c2goFolderDataService: FolderDataService,
        private folderTreeDataService: DynamicFolderTreeDataService,
        private sharepointDataService: SharepointDataService,
        private processService: ProcessService,
        public PS: PermissionService,
        private filePopupServiceService: FilePopupServiceService,
        private gatewayService: AppGatewayService,
        private toastrService: ToastrService,
    ) {

        this.setDatasource();
        // this.dynamicTreeDataAsArray$ = this.dynamicTreeDataSource.connect().pipe(shareReplay({refCount: true, bufferSize: 1}));
        firstValueFrom(this.store.select(getCommissionsFetched)).then((fetched) => {
            if (!fetched) {
                commissionResolver.resolve();
            }
        });
        firstValueFrom(this.store.select(getTagFetched)).then((fetched) => {
            if (!fetched) {
                tagResolver.resolve();
            }
        });

        this.FolderWithTypeSelected$ = this.FolderMultisilect$.pipe(
            switchMap((selectedIds) => this.c2goFolderDataService.getFolderByIds(selectedIds, true)),
            map((folders) => folders.some((f) => f.Type != null)),
        );

        this.subscriptions.push(
            this.PreviousSelectedFolderId$.subscribe(),
            this.SelectedFolderId$.pipe(switchMap((id) => (id ? this.folderDataService.getFolderById(id) : of(null)))).subscribe((folder) => {
                if (folder) {
                    this.HasFolderEditPermission = folder.CanEdit;
                } else {
                    this.HasFolderEditPermission = true;
                }
            }),
        );

        this.Folder$ = combineLatest([this.SelectedFolderId$, this.onInit$.pipe(map((v) => !!v))])
            .pipe(
                map(([folderId]) => folderId),
                distinctUntilChanged(),
                tap(() => this.LoadingFiles$.next(true)),
                switchMap((folderId) => {
                    return combineLatest([
                        this.store.select(getPartner).pipe(
                            filter(p => !!p),  //logout fix
                            map(p => p.PartnerTypeId === PartnerTypeEnum.TSB),
                            distinctUntilChanged(),
                            switchMap(isTsb => {
                                // if (isTsb) {
                                //     return this.foldersBySelectedParent$.pipe(switchMap(folders => {
                                //         return this.SelectedFolderId$.pipe(
                                //             distinctUntilChanged(),
                                //             switchMap(id => id ? this.folderDataService.getFolderById(id) : of(null)),
                                //             first(),
                                //             map(parent => {
                                //                 if (parent?.Type === FolderTypes.commission) {
                                //                     return folders.filter(f => f.Type !== FolderTypes.construction_diary_root && f.Type !== FolderTypes.event_root && f.Type !== FolderTypes.transmission_root);
                                //                 } else {
                                //                     return folders.filter((f) => !(f.Type == FolderTypes.email_attachment && f.ParentId == null));
                                //                 }
                                //             }),
                                //         )
                                //     }));
                                // } else {
                                    return this.foldersBySelectedParent$
                                // }
                            })
                        ),
                        (typeof folderId === 'string' ? of([] as FileEntity[]) : this.fileDataService.GetFilesStateFromFolder$(folderId || 0)).pipe(
                            filter(isNotNullOrUndefined),
                            distinctUntilChanged((a, b) => a.length === b.length && a.every((e, index) => e.Id === b[index].Id && e.UpdatedAt.getTime() === b[index].UpdatedAt.getTime())),
                            tap(() => this.LoadingFiles$.next(false)),
                            switchMap((files) =>
                                this.FilterValues$.pipe(
                                    map((filter) => {
                                        let filteredFiles = files.slice();
                                        if (filter.tagIds?.length) {
                                            filteredFiles = filteredFiles.filter((file) => file.TagIds.length >= filter.tagIds.length && filter.tagIds.every((tag) => file.TagIds.includes(tag.id)));
                                        }
                                        if (filter.commissionIds?.length) {
                                            filteredFiles = filteredFiles.filter((file) => file.ContractId && filter.commissionIds.some((c) => c.id === file.ContractId));
                                        }
                                        if (filter.createdAt?.from) {
                                            filteredFiles = filteredFiles.filter((f) => filter.createdAt?.from.isSameOrBefore(f.CreatedAt, 'date'));
                                        }
                                        if (filter.createdAt?.to) {
                                            filteredFiles = filteredFiles.filter((f) => filter.createdAt?.to.isSameOrAfter(f.CreatedAt, 'date'));
                                        }
                                        if (filter.updatedAt?.from) {
                                            filteredFiles = filteredFiles.filter((f) => filter.updatedAt?.from.isSameOrBefore(f.UpdatedAt, 'date'));
                                        }
                                        if (filter.updatedAt?.to) {
                                            filteredFiles = filteredFiles.filter((f) => filter.updatedAt?.to.isSameOrAfter(f.UpdatedAt, 'date'));
                                        }
                                        return filteredFiles;
                                    }),
                                ),
                            ),
                        ),

                        this._sharepointMode$.pipe(
                            switchMap(sharepointMode => {
                                return sharepointMode && typeof folderId === 'string' ? this.sharepointDataService.getFilesByParent(folderId).pipe(switchMap(files =>
                                    this.FilterValues$.pipe(
                                        map((filter) => {
                                            let filteredFiles = files.slice();
                                            // if (filter.tagIds?.length) {
                                            //     filteredFiles = filteredFiles.filter((file) => file.TagIds.length >= filter.tagIds.length && filter.tagIds.every((tag) => file.TagIds.includes(tag.id)));
                                            // }
                                            // if (filter.commissionIds?.length) {
                                            //     filteredFiles = filteredFiles.filter((file) => file.ContractId && filter.commissionIds.some((c) => c.id === file.ContractId));
                                            // }
                                            if (filter.createdAt?.from) {
                                                filteredFiles = filteredFiles.filter((f) => filter.createdAt?.from.isSameOrBefore(f.CreatedAt, 'date'));
                                            }
                                            if (filter.createdAt?.to) {
                                                filteredFiles = filteredFiles.filter((f) => filter.createdAt?.to.isSameOrAfter(f.CreatedAt, 'date'));
                                            }
                                            if (filter.updatedAt?.from) {
                                                filteredFiles = filteredFiles.filter((f) => filter.updatedAt?.from.isSameOrBefore(f.UpdatedAt, 'date'));
                                            }
                                            if (filter.updatedAt?.to) {
                                                filteredFiles = filteredFiles.filter((f) => filter.updatedAt?.to.isSameOrAfter(f.UpdatedAt, 'date'));
                                            }
                                            return filteredFiles;
                                        }),
                                    ))) : of([] as SharepointObjectEntity[]);
                            }),
                            ),
                    ]);
                }),
            )
            .pipe(
                map(([folders, files, sharePointFiles]) => ({
                    folders: folders
                        .slice()
                        .sort(sortByName),
                    files: files?.slice().sort(sortByName),
                    sharePointFiles: sharePointFiles?.slice().sort(sortByName),
                })),
                takeUntil(this.onDestroy$),
                shareReplay({ refCount: true, bufferSize: 1 }),
            );
        this.ShownElements$ = combineLatest([this.store.select(getToken).pipe(filter(isNotNullOrUndefined)), this.Folder$]).pipe(
            map(
                ([token, folder]) => [
                    ...folder.folders.map<ExplorerElement>((f) => ({
                        id: f.Id,
                        isFolder: true,
                        isLink: false,
                        name: f.Name,
                        createdAt: f.CreatedAt,
                        updatedAt: f.UpdatedAt,
                        prevSelected$: this.PreviousSelectedFolderId$.pipe(
                            map((id) => id === f.Id),
                            distinctUntilChanged(),
                        ),
                        additionalColumns: f.AdditionalFields,
                        searchStrings: [f.Name].map((s) => s.toLowerCase()),
                    })),
                    ...folder.files.map<ExplorerElement>((f:FileEntity) => ({
                        id: f.Id,
                        shared: f.Shared,
                        isFolder: false,
                        isLink: !!f.LinkedDocumentId,
                        name: f.Name,
                        size: f.GetLastVersion()?.Size,
                        createdAt: f.CreatedAt,
                        updatedAt: f.UpdatedAt,
                        fileType: f.MIMETypeDescription,
                        thumbnailPath: f.GetLastVersion()?.HasThumbnail ? this.BaseUrl + f.GetLastVersion().GetThumbnailLink(token) : null,
                        icon: f.FileIcon,
                        isChecked: f?.Checked,
                        additionalColumns: new Map<string,string>(),
                        isCharged: f?.State ? f.State === DocumentState.DocumentStateCharged : false,
                        prevSelected$: this.CurrentSelectedFileId$.pipe(
                            map((id) => id === f.Id),
                            distinctUntilChanged(),
                        ),
                        searchStrings: [f.Name, f.Description].map((s) => s.toLowerCase()),
                        remark: f?.Remark,
                    })),
                    ...folder.sharePointFiles.map<ExplorerElement>((f: SharepointObjectEntity) => {
                        return {
                        id: f.Id,
                        shared:false,
                        isFolder: false,
                        isLink: false,
                        name: f.Name,
                        size: f.Size,
                        createdAt: f.CreatedAt,
                        updatedAt: f.UpdatedAt,
                        fileType: GetFileMimeTypeText(f.MimeType),
                        thumbnailPath: f.ThumbnailUrl,
                        icon: getFileIconByMimeType(f.MimeType),
                        isChecked: false,
                        isCharged: false,
                        additionalColumns: f.Fields,
                        prevSelected$: of(false), //todo
                        searchStrings: [f.Name].map((s) => s.toLowerCase()),
                        remark: null,
                        external: {
                            isSharepoint: true,
                            directOpenUrl: f.Url,
                        }
                        };
                    }),
                ],
                // searchString
                //     ? [
                //           ...folder.folders
                //               .filter((f) => f.Name.toLocaleLowerCase().includes(searchString))
                //               .map<ExplorerElement>((f) => ({
                //                   id: f.Id,
                //                   isFolder: true,
                //                   isLink: false,
                //                   name: f.Name,
                //                   createdAt: f.CreatedAt,
                //                   updatedAt: f.UpdatedAt,
                //                   searchStrings: [f.Name],
                //                   // prevSelected: f.Id === prevFolderId,
                //               })),
                //           ...folder.files
                //               .filter((f) => [f.Name, f.Description].filter(isNotNullOrUndefined).some((v) => stringSearch(v, searchString)))
                //               .map<ExplorerElement>((f) => ({
                //                   id: f.Id,
                //                   shared: f.Shared,
                //                   isFolder: false,
                //                   isLink: !!f.LinkedDocumentId,
                //                   name: f.Name,
                //                   size: f.GetLastVersion()?.Size.toString(),
                //                   createdAt: f.CreatedAt,
                //                   updatedAt: f.UpdatedAt,
                //                   fileType: f.MIMETypeDescription,
                //                   thumbnailPath: f.GetLastVersion()?.HasThumbnail ? this.BaseUrl + f.GetLastVersion().GetThumbnailLink(token) : null,
                //                   icon: f.FileIcon,
                //                   isChecked: f?.State ? f.State === DocumentState.DocumentStateChecked : false,
                //                   searchStrings: [f.Name, f.Description],
                //                   // prevSelected: f.Id === prevFileId,
                //               })),
                //       ]
                //     :
            ),
            switchMap((elements) =>
                this.DataSearchForm.valueChanges.pipe(
                    startWith(''),
                    map(() => this.DataSearchForm.value?.trim().toLowerCase()),
                    distinctUntilChanged(),
                    map((searchQuery) => (searchQuery ? elements.filter((e) => e.searchStrings.some((s) => s.includes(searchQuery))) : elements)),
                ),
            ),
            takeUntil(this.onDestroy$),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );

        this.PathIds$ = this.Path$.pipe(map((folders) => folders?.map((f) => f.Id)));
        this.ShownElementsTableDataSource$ = combineLatest([this.afterViewInit$.pipe(filter((v) => !!v)), this.ShownElements$]).pipe(
            map(([, elements]) => {
                const ret = new TableVirtualScrollDataSource<ExplorerElement>(elements);
                ret.sort = this.matSortDOM;
                ret.sortingDataAccessor = (item, property) => {
                    switch (property) {
                        case 'name':
                            return item.name.toLowerCase();
                        case 'fileType':
                            return item.fileType?.toLowerCase();
                        default:
                            return item[property];
                    }
                };
                return ret;
            }),
        );

        this.SelectedFolderId$.pipe(
            takeUntil(this.onDestroy$),
            distinctUntilChanged(),
            switchMap(() => this.ShownElements$.pipe(skip(1), take(1), takeUntil(this.onDestroy$))),
            withLatestFrom(this.PreviousSelectedFolderId$),
        ).subscribe(([data, prevFolderId]) => {
            const index = data.findIndex((e) => e.id === prevFolderId);
            if (index !== -1) {
                setTimeout(() => {
                    this.scrollViewportForList?.scrollToIndex(index);
                    this.scrollViewportForTile?.scrollToIndex(index);

                    setTimeout(() => {
                        const elementRef = (this.scrollViewportForTile || this.scrollViewportForList)?.elementRef;
                        const element = (this.scrollViewportForTile || this.scrollViewportForList)?.elementRef.nativeElement.querySelector('.prev-selected');
                        (element as HTMLElement)?.focus();
                    }, 1);
                }, 1);
            }
        });
        this.IsAllSelected$ = combineLatest([this.FileMultisilect$, this.FolderMultisilect$, this.ShownElements$]).pipe(
            map(([selectedFiles, selectedFolders, allElements]) => {
                return allElements && selectedFiles && selectedFolders && allElements.length === selectedFiles.length + selectedFolders.length;
            }),
        );
        this.ClickMove$.pipe(
            takeUntil(this.onDestroy$),
            withLatestFrom(this.FileMultisilect$, this.FolderMultisilect$, this.SelectedFolderId$),
            tap(([, selectedFileIds, selectedFolderIds, folderId]) => {
                if (typeof folderId === 'string') {
                    throw new Error('Move is only implemented for dms folders');
                }
                this.moveFileFolderService.MoveFileFolder(selectedFileIds, selectedFolderIds, folderId);
                this.ToggleMultiselect();
            }),
        ).subscribe();
        this.Path$.pipe(
            takeUntil(this.onDestroy$),
            filter(isNotNullOrUndefined),
            tap((path) => {
                this.FolderNameForm.patchValue(path[path.length - 1].Name);
                this.BreadcrumbScrollToTheEnd();
                this.expandTree(path);
            }),
        ).subscribe();
        this.ClickDownload$.pipe(
            takeUntil(this.onDestroy$),
            withLatestFrom(this.store.select(getFilesWithoutHidden)),
            tap(([, files]) => {
                if (this.FileMultisilect$.value?.length === 1 && !this.FolderMultisilect$.value?.length) {
                    DownloadVersions(files.filter((f) => this.FileMultisilect$.value.includes(f.Id)).map((f) => f.GetLastVersion()));
                } else {
                    DownloadZip(this.FileMultisilect$.value, this.FolderMultisilect$.value);
                }
                this.ToggleMultiselect();
            }),
        ).subscribe();
    }

    @Input() set SelectedFolderId(value: folderIdType) {
        this.SelectedFolderId$.next(value);
        this.Path$.pipe(
            take(1),
            tap(() => {
                setTimeout(() => this.ScrollTreeToFolder(value), 1);
            }),
        ).subscribe();
    }
    // hasChild = (_: number, _nodeData: DynamicFolderTreeFlatNode) => _nodeData.expandable;
    private setFolderDataServiceMode() {
        this.folderDataService.setMode(this._sharepointMode$.value ? 'sharepoint' : 'c2go');
    }
    ngOnInit(): void {
        this.setFolderDataServiceMode();
        this.onInit$.next(true);
        this.subscriptions.push(
            this.OpenMailDialog$.pipe(

                withLatestFrom(this.FileMultisilect$),
                tap(([, files]) => {
                    this.store.select(getFileById({id: files[0]})).pipe(take(1))
                        .subscribe(file => {
                            this.dialog.open<EmailEditorComponent, EmailEditorComponentDialogData>(EmailEditorComponent, {
                                ...EmailEditorComponentDialogConfig,
                                data: {
                                    ...( this.EmailEditorDialogDataForFilePreview || {}),
                                    FileAttachmntFileIds: files,
                                    CommissionId: file?.ContractId,
                                },
                            });
                        })
                })
            ).subscribe(),
            this.FileClicked.subscribe((id) => {
                if (!this.DisableRoutingParams) {
                    this.router.navigate([], {
                        relativeTo: this.route,
                        queryParams: {
                            documentId: id,
                        },
                        queryParamsHandling: 'merge',
                        replaceUrl: true,
                    });
                }
            }),
            this.SelectedFolderId$.pipe(
                distinctUntilChanged(),
                tap((folderId) => {
                    if (!this.DisableRoutingParams) {
                        this.router.navigate([], {
                            relativeTo: this.route,
                            queryParams: {
                                folderId,
                            },
                            queryParamsHandling: 'merge',
                            replaceUrl: true,
                        });
                    }
                }),
            ).subscribe(),
        );
    }

    async onClickDetectDocuments() {
        const fileIds = await firstValueFrom(this.FileMultisilect$);
        if (!fileIds?.length) {
            return;
        }
        const files = await firstValueFrom(this.fileDataService.GetFilesById(fileIds));

        const versionIds = files.map(file => file.GetLastVersion().Id);

        // Falls Verknüpfungen ausgewählt wurden, werden die Ids der originalen Dateien in das Array geschrieben
        const originalFileIds = files.map(file => {
            if (file.LinkedDocumentId) {
                return file.LinkedDocumentId;
            }
            return file.Id;
        });

        await this.fileDataService.setDetectDocumentPrio(versionIds, originalFileIds);
        this.ToggleMultiselect();
    }

    public ScrollTreeToFolder(id: folderIdType) {
        // @ts-ignore
        if (this.treeWrapperScrollbar && this.dynamicTreeDataSource._expandedData) {
            this.treeWrapperScrollbar.scrollToIndex(
                // @ts-ignore
                this.dynamicTreeDataSource._expandedData.value.findIndex((node) => node.Id === id),
                'smooth',
            );
        }
    }

    public BreadcrumbScrollToTheEnd() {
        if (this.breadcrumbScrollbar) {
            setTimeout(() => {
                this.breadcrumbScrollbar.SimpleBar.getScrollElement().scrollLeft = this.breadcrumbScrollbar.SimpleBar.getScrollElement().scrollWidth;
            }, 1);
        }
    }

    public SortTableData(sort: Sort, dataSource: TableVirtualScrollDataSource<ExplorerElement>) {

        if (!dataSource.sort) {
            dataSource.sort = this.matSortDOM;
        }
        const selectedFolderId = this.SelectedFolderId$.value;
        if (!(typeof selectedFolderId === 'string')) {
            this.sortService.SetSortable(selectedFolderId, {
                id: sort.direction ? sort.active : null,
                start: sort.direction || 'asc',
                disableClear: false,
            });
        }
    }

    ClickNode2(node: DynamicFolderTreeFlatNode<number> | DynamicFolderTreeFlatNode<string>) {
        if (node.idIsString) {
            if (node.item.isFolder) {
                this.SelectedFolderId$.next(node.stringId);
            } else {
                alert('notImplemented')
            }
        } else {
            if (node.item.isFolder) {
                this.SelectedFolderId$.next(node.numberId);
            } else {
                this.fileClick(node.numberId);
            }
        }
    }

    ClickFolder(id: number | string) {
        if (this.Multiselect$.value) {
            if (typeof id === 'string') {
                alert('not implemented')
            } else {
                if (this.FolderMultisilect$.value.includes(id)) {
                    this.FolderMultisilect$.next(this.FolderMultisilect$.value.slice().filter((fId) => fId !== id));
                } else {
                    this.FolderMultisilect$.next([...this.FolderMultisilect$.value.slice(), id]);
                }
            }
        } else {
            this.SelectedFileId$.next(null);
            this.SelectedFolderId$.next(id);
        }
    }

    ClickFile(id: number) {
        if (this.Multiselect$.value) {
            if(typeof id === 'string') {
                alert('not implemented')
            } else {
                if (this.FileMultisilect$.value.includes(id)) {
                    this.FileMultisilect$.next(this.FileMultisilect$.value.slice().filter((fId) => fId !== id));
                } else {
                    this.FileMultisilect$.next([...this.FileMultisilect$.value.slice(), id]);
                }
            }
        } else {
            this.fileClick(id);
            this.setImageIds();
        }
    }

    CilickItem(item: ExplorerElement) {
        if (item.isFolder) {
            this.ClickFolder(item.id);
        } else {
            if (!item.external && typeof item.id === 'number') {
                this.ClickFile(item.id);
            } else {
                if (typeof item.id === 'string' && item.external.isSharepoint) {
                    this.openSharepointObjectDetailsDialog(item.id)
                } else {
                    throw new Error('Invalid item');
                }
            }
        }
    }

    // Item Double Click
    DoubleClickItem(item: ExplorerElement) {
        // Return if Item is Folder or Multiselect is Active
        if (item.isFolder) return;
        if (this.Multiselect$.value) return;

        if (item.isFolder) {
            this.ClickFolder(item.id);
        } else {
            if (!item.external && typeof item.id === 'number') {
                this.filePopupServiceService.openFullscreen(item.id);
            } else {
                if (typeof item.id === 'string' && item.external.isSharepoint) {
                    if (item.external.directOpenUrl) {
                        window.open(item.external.directOpenUrl, '_blank');
                    }
                } else {
                    throw new Error('Invalid item');
                }
            }
        }
    }


    public UploadClick(FolderId: number) {
        this.FileUploadClicked.emit(FolderId);
        if (this.preventFileUploadClick) {
            return;
        }
        this.dialog.open<DaveFileUploadDialogComponent, DaveFileUploadDialogComponentDialogData>(DaveFileUploadDialogComponent, {
            ...DaveFileUploadDialogComponent.DefaultConfig,
            data: { ...this.FileUploadConfig, FolderId },
        });
    }
    public getFileIdsFromCurrentDirectory$(): Observable<null | fileIdType[]> {
        return this.ViewStyle$.pipe(
            switchMap((vs) => {
                if (vs === DmsViewStyle.Tile) {
                    return this.ShownElements$.pipe(map((elements) => elements.filter((e) => !e.isFolder).map((e) => e.id)));
                } else if (vs === DmsViewStyle.List) {
                    return this.ShownElementsTableDataSource$.pipe(
                        map((ds) =>
                            ds
                                ._orderData(ds.filteredData)
                                .filter((d) => !d.isFolder)
                                .map((d) => d.id),
                        ),
                    );
                }
                return of(null);
            }),
        );
    }
    private fileClick(fileId: number) {
        if (typeof fileId === 'string') {
            alert('not implemented');
            return;
        }
        this.FileClicked.emit(fileId);
        this.SelectedFileId$.next(fileId);
        if (this.preventFileClick) {
            return;
        }
        firstValueFrom(this.getFileIdsFromCurrentDirectory$()).then((fileIds) => {
            this.openFileDialogs.forEach((d) => d.close());
            this.openFileDialogs = [];
            const dialogRef = this.dialog.open<DaveFilePreviewComponent, DaveFilePreviewComponentDialogData>(DaveFilePreviewComponent, {
                ...DaveFilePreviewComponent.DefaultConfig,
                data: {
                    fileId,
                    emailEditorDialogData: this.EmailEditorDialogDataForFilePreview,
                    fileExplorerContext: fileIds?.every(id => typeof id === 'number')
                        ? {
                              directoryFileIds: fileIds as number[],
                          }
                        : undefined,
                },
            });
            this.openFileDialogs.push(dialogRef);
            dialogRef.afterClosed().subscribe(() => {
                this.openFileDialogs = this.openFileDialogs.filter((d) => d !== dialogRef);
            });
        });
    }

    setImageIds() {
        firstValueFrom(combineLatest([this.getFileIdsFromCurrentDirectory$(), this.SelectedFileId$])).then(([fileIds, fileId]) => {
            if (typeof fileId === 'string' || fileIds.some(id => typeof id === 'string')) {
                return;
            }
            this.fileDataService
                .GetFilesById(uniqArray([...fileIds, fileId].filter(isNotNullOrUndefined) as number[]))
                .pipe(
                    take(1),
                    map((files) => files.filter((f) => f.MIMEType.indexOf('image/') > -1).map((f) => f.Id)),
                )
                .subscribe((imgIds) => {
                    this.fileExplorerContext.emit({ directoryFileIds: imgIds });
                });
        });
    }

    ClickAddFolder() {
        this.dialog.open(NewFolderDialogComponent, {
            ...NewFolderDialogComponent.DefaultConfig,
            data: {
                rootFolderId: this.SelectedFolderId$.value,
            } as NewFolderDialogComponentDialogData,
        });
    }

    async ClickAddFilesToProcess() {
        const selectedFileIds = await firstValueFrom(this.FileMultisilect$.pipe(take(1)));
        if (!selectedFileIds?.length) {
            return;
        }
        await this.processService.openAddFileToProcessDialog(selectedFileIds);
        this.ToggleMultiselect();
    }

    async ClickStartProcessWithFiles() {
        const selectedFileIds = await firstValueFrom(this.FileMultisilect$.pipe(take(1)));
        if (!selectedFileIds?.length) {
            return;
        }

        // Dynamisch importieren, um zyklische Abhängigkeiten zu vermeiden
        const { StartProcessDialogComponent } = await import(
            '../../../process/components/start-process-dialog/start-process-dialog.component'
            );

        this.dialog.open(StartProcessDialogComponent, {
            ...StartProcessDialogComponent.DefaultConfig,
            data: {
                fileId: selectedFileIds.length === 1 ? selectedFileIds[0] : null,
                fileIds: selectedFileIds.length > 1 ? selectedFileIds : null,
            },
        });
        this.ToggleMultiselect();
    }

    ClickDelete(): void {
        this.appDialog
            .OpenConfirmationDialog({
                paragraph: `Ausgewählte Dateien wirklich löschen?`,
                styleDelete: true,
            })
            .subscribe(([result]) => {
                if (result) {
                    this.ShowNotFoundError = false;
                    this.FolderMultisilect$.value.forEach((id) => this.store.dispatch(FolderActionTypes.DeleteFolder({ Payload: id })));
                    this.FileMultisilect$.value.forEach((id) => this.store.dispatch(FilesActionTypes.DeleteFileRequest({ Payload: { DocumentId: id.toString() } })));
                    this.ToggleMultiselect();
                }
            });
    }

    ClickShare() {
        this.FolderMultisilect$.value.forEach((id) =>
            this.store.dispatch(
                FolderActionTypes.ModifyFolder({
                    Payload: {
                        id,
                        shared: this.Sharing$.value,
                    },
                }),
            ),
        );
        this.FileMultisilect$.value.forEach((id) =>
            this.store.dispatch(
                FilesActionTypes.ModifyFileRequest({
                    Payload: {
                        DocumentId: id.toString(),
                        Shared: this.Sharing$.value,
                    },
                }),
            ),
        );
        this.ToggleMultiselect();
    }

    MultiselectMasterToggle(data: ExplorerElement[]) {
        if (this.FileMultisilect$.value?.length + this.FolderMultisilect$.value?.length === data.length) {
            this.FileMultisilect$.next([]);
            this.FolderMultisilect$.next([]);
        } else {
            const folderIds = data
                .slice()
                .filter((item) => item.isFolder)
                .map((item) => item.id);
            const fileIds = data
                .slice()
                .filter((item) => !item.isFolder)
                .map((item) => item.id);

            if (folderIds.every(id => typeof id === 'number')) {
                this.FolderMultisilect$.next(folderIds as number[]);
            }
            if (fileIds.every(id => typeof id === 'number')) {
                this.FileMultisilect$.next(fileIds as number[]);
            }
        }
    }

    ToggleMultiselect() {
        this.Multiselect$.next(!this.Multiselect$.value);
        this.FileMultisilect$.next([]);
        this.FolderMultisilect$.next([]);
    }

    IsSelected(item: ExplorerElement) {
        if (typeof item.id !== 'number') return false;
        return (item.isFolder && this.FolderMultisilect$.value.includes(item.id)) || (!item.isFolder && this.FileMultisilect$.value.includes(item.id));
    }

    SetViewStyle(viewStyle: DmsViewStyle) {
        this.store.dispatch(
            new ChangeSettings({
                DmsViewStyle: viewStyle,
            }),
        );
        /* D277-4627 - Fix beim scrollen nach oben, das Elemente zurück springen lässt */
        setTimeout(() => {
            if (this.scrollViewportForList || this.scrollViewportForTile) {
                var scrollable = null;
                if(this.scrollViewportForList) {
                    scrollable = this.scrollViewportForList?.elementRef.nativeElement;
                }
                else {
                    scrollable = this.scrollViewportForTile?.elementRef.nativeElement;
                }
                if (scrollable && scrollable.children) {
                    const spacer = scrollable.children[1];
                    if (spacer && spacer.classList.contains('cdk-virtual-scroll-spacer')) {
                        scrollable.insertBefore(spacer, scrollable.firstChild);
                    } else {
                        console.error("Spacer nicht gefunden");
                    }
                } else {
                    console.error("Scrollable nicht gefunden");
                }
            }
        }, 1000);
    }

    SetFocus(a) {
        setTimeout(() => a.focus());
    }

    ngAfterViewInit(): void {
        this.sizing();
        this.afterViewInit$.next(true);
        // fix für buttonwraper nach dem routen auf die Kundenseite (mobile) D277-1930
        setTimeout(() => this.buttonWrapper?.renderIfOverflown(), 10);
        setTimeout(() => this.buttonWrapper?.renderIfOverflown(), 500);
        setTimeout(() => this.buttonWrapper?.renderIfOverflown(), 1000);
        setTimeout(() => this.buttonWrapper?.renderIfOverflown(), 1500);
        setTimeout(() => this.buttonWrapper?.renderIfOverflown(), 2000);
        setTimeout(() => this.buttonWrapper?.renderIfOverflown(), 4000);
        /* D277-4627 - Fix beim scrollen nach oben, das Elemente zurück springen lässt */
        setTimeout(() => {
            if (this.scrollViewportForList || this.scrollViewportForTile) {
                var scrollable = null;
                if(this.scrollViewportForList) {
                    scrollable = this.scrollViewportForList?.elementRef.nativeElement;
                }
                else {
                    scrollable = this.scrollViewportForTile?.elementRef.nativeElement;
                }
                if (scrollable && scrollable.children) {
                    const spacer = scrollable.children[1];
                    if (spacer && spacer.classList.contains('cdk-virtual-scroll-spacer')) {
                        scrollable.insertBefore(spacer, scrollable.firstChild);
                    } else {
                        console.error("Spacer nicht gefunden");
                    }
                } else {
                    console.error("Scrollable nicht gefunden");
                }
            }
        }, 1000);

        this.subscriptions.push(
            this.SelectedFolderId$.pipe(distinctUntilChanged()).subscribe((folderId) => {
                this.DataSearchForm.setValue('');
            }),

            this.ViewStyle$.pipe(
                distinctUntilChanged(),
                filter((v) => v === DmsViewStyle.List),
                switchMap(() => this.SelectedFolderId$.pipe(distinctUntilChanged())),
            ).subscribe((folderId) => {
                const sort: MatSortable = typeof folderId === 'string' ? {disableClear: false, id: '', start: 'asc'} : this.sortService.GetSortable(folderId);

                if (this.matSortDOM) {
                    this.matSortDOM.active = sort.id;
                    this.matSortDOM.direction = sort.start;
                    this.matSortDOM.disableClear = sort.disableClear;
                } else {
                    let t = 0;
                    const step = 300;
                    const max = 2000;

                    const int = setInterval(() => {
                        t += step;
                        this.matSortDOM?.sort(sort);
                        if (t >= max || this.matSortDOM) {
                            clearInterval(int);
                        }
                    }, step);
                }
            }),
        );
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
        this.subscriptions.forEach((s) => s.unsubscribe());

        this.OpenMailDialog$?.complete();
        this.Minimalistic$?.complete();
        this.ViewStyleOverride$?.complete();
        this.Small$?.complete();
        this.SelectedFolderId$?.complete();
        this.SelectedFileId$?.complete();
        this.FolderMultisilect$?.complete();
        this.FileMultisilect$?.complete();
        this.Multiselect$?.complete();
        this.Sharing$?.complete();
        this.LoadingFiles$?.complete();
        this.LoadingFolders$?.complete();
        this.onInit$?.complete();
        this.afterViewInit$?.complete();
        this.FilterValues$?.complete();
        this.ClickMove$.complete();
        this.ClickDownload$.complete();
    }

    Options(event: Event, folderId: folderIdType, ignore: boolean) {
        if (!ignore) {
            event.preventDefault();
            event.stopPropagation();
            switch (this.folderDataService.getMode()) {
                case 'c2go':
                    if (typeof folderId === 'number') {
                        this.dialog.open<ViewFolderComponent, ViewFolderComponentDialogData>(ViewFolderComponent, {
                            data: {
                                FolderId: folderId,
                            },
                            maxWidth: '100vw',
                            hasBackdrop: false,
                            panelClass: 'custom-dialog-class-for-overlay-on-right-side',
                        });
                    } else {
                        throw new Error('invalid id')
                    }
                    break;
                case 'sharepoint':
                    if (typeof folderId === 'string') {
                        this.openSharepointObjectDetailsDialog(folderId);
                    } else {
                        throw new Error('invalid id');
                    }
                    break;
                default:
                    throw new Error('invalid mode');
            }
        }
    }

    private async expandTree(path?: { Name: string; Id: folderIdType; }[]) {
        if (!path?.length) {
            this.dynamicTreeControl.collapseAll();
        }
        if (path?.length) {
            await this.dynamicTreeControl.expandFolder(path[path.length - 1].Id);
        }
    }
    public ToggleSidenav() {
        this.drawer.toggle().then((open) => {
            if (open) {
                setTimeout(() => this.buttonWrapper.render());
            } else {
                this.buttonWrapper.render();
            }
        });
    }

    protected readonly FileLinkIcon = FileLinkIcon;

    async onUploadMultipleUglClick() {
        const fileIds = await firstValueFrom(this.FileMultisilect$);
        if (!fileIds?.length) {
            return;
        }
        const files = await firstValueFrom(this.fileDataService.GetFilesById(fileIds));

        const versionIds = files.map(file => file.GetLastVersion().Id).map(n=> n.toString());


        //let useLVCalculation = partner.InvoiceEditorUseLVCalculation;




        this.toastrService.info('Import der ausgwählten UGL Dateien gestartet.', 'Die UGL Dateien werden eingespielt.');
        const result = await this.gatewayService.Request({ GabeImportMultipleFiles: {
                VersionIds: versionIds,
            } }).catch((e) => {
            this.store.dispatch(BaseActionTypes.ErrorAction({ Payload: { ToasterMessage: 'Import fehlgeschlagen', Err: e } }));
        });
        this.ToggleMultiselect();
    }

    onMergePdfClick() {
        const dialogRef = this.dialog.open<SortFilesDialogComponent, SortFilesDialogComponentDialogData>(SortFilesDialogComponent, {
            ...SortFilesDialogComponent.DefaultConfig,
            data: {
                headline: 'PDFs zusammenführen',
                documentIds: this.FileMultisilect$.value,
                showFileNameForm: true,
                fileName: NEW_DOCUMENT_DEFAULT_NAME + '.pdf',
            },
        });
        dialogRef.componentInstance.submitClick.pipe(takeUntil(dialogRef.beforeClosed())).subscribe(() => {
            this.ls.startLoading('file-explorer--merge-pdf');
            firstValueFrom(this.actions$.pipe(ofType(FilesActionTypes.MergePdfVersionsFailure, FilesActionTypes.MergePdfVersionsSuccess))).then((action) => {
                this.ls.endLoading('file-explorer--merge-pdf');
                if (action.type === FilesActionTypes.MergePdfVersionsSuccess.type) {
                    dialogRef.close();
                    this.ToggleMultiselect();
                }
            });
            this.store.dispatch(
                FilesActionTypes.MergePdfVersionsRequest({
                    Payload: {
                        FolderId: this.SelectedFolderId$.value ? this.SelectedFolderId$.value.toString() : null,
                        VersionIds: dialogRef.componentInstance.documentsSorted.map((d) => d.GetLastVersion().Id.toString()),
                        DocumentIds: dialogRef.componentInstance.documentsSorted.map((d) => d.Id.toString()),
                        DocumentName: dialogRef.componentInstance.fileName,
                    },
                }),
            );
        });
    }

    protected readonly FileEntityDocumentStateNames = FileEntityDocumentStateNames;
    protected readonly DocumentState = DocumentState;
    protected readonly ProcessMeta = ProcessMeta;
    protected readonly InvoiceEditorMeta = InvoiceEditorMeta;


    protected readonly PageMetaMaterial = MaterialPageMeta;

    protected dataSouerceAsObservable$ = new BehaviorSubject<typeof this.dynamicTreeDataSource>(null)
    private setDatasource() {
        if (this._sharepointMode$.value) {
            const dynamicTreeControl = new SharepointFolderTreeControl(
                this.sharepointDataService, // todo
                (node: DynamicFolderTreeFlatNode<string>) => node.level,
                (node: DynamicFolderTreeFlatNode<string>) => node.expandable,
            );
            this.dynamicTreeControl = dynamicTreeControl;
            this.dynamicTreeDataSource = new SharepointFolderTreeDataSource(dynamicTreeControl, this.sharepointDataService, this.sharepointRootFolder.Id, isNotNullOrUndefined(this.sharepointRootFolder.NameOverride) ? new Map<string, string>([[this.sharepointRootFolder.Id, this.sharepointRootFolder.NameOverride]]) : null);
        } else {
            const dynamicTreeControl = new FolderTreeControl(
                this.c2goFolderDataService,
                (node: DynamicFolderTreeFlatNode<number>) => node.level,
                (node: DynamicFolderTreeFlatNode<number>) => node.expandable,
            );
            this.dynamicTreeControl = dynamicTreeControl;
            this.dynamicTreeDataSource = new DynamicFolderTreeDataSource(dynamicTreeControl, this.folderTreeDataService, this.folderTreeDataService.initialData());
        }
        this.dataSouerceAsObservable$.next(this.dynamicTreeDataSource);
        firstValueFrom(this.Path$).then(path => {
            this.expandTree(path);
            }
        )

    }

    protected async onFolderNavigateUpClick() {
        const path = await firstValueFrom(this.Path$);
        this.SelectedFolderId$.next(path.length === 1 ? null : path[path.length - 2].Id)
    }

    protected readonly isNotNullOrUndefined = isNotNullOrUndefined;

    protected goToRootFolder() {
        if (this._sharepointRootFolder) {
            if (this.SelectedFolderId$.value !== this._sharepointRootFolder.Id) {
                this.SelectedFolderId$.next(this._sharepointRootFolder.Id);
            }
        } else {
            this.SelectedFolderId$.next(null)
        }
    }

    private openSharepointObjectDetailsDialog(id: string) {
        this.openFileDialogs.forEach((d) => d.close());
        this.openFileDialogs = [];
        const dialogRef = this.dialog.open<SharepointObjectPreviewDialogComponent, SharepointObjectPreviewDialogComponentDialogData, SharepointObjectPreviewDialogComponentDialogReturnData>(SharepointObjectPreviewDialogComponent, {
            ...SharepointObjectPreviewDialogComponent.DefaultConfig,
            data: {
                id,
            },
        });
        this.openFileDialogs.push(dialogRef);
        dialogRef.afterClosed().subscribe(() => {
            this.openFileDialogs = this.openFileDialogs.filter((d) => d !== dialogRef);
        });
    }
}
